<dx-popup
    [showTitle]="true"
    [title]="'Edit Grid Configuration: ' + fieldProps?.label?.text"
    [height]="gridConfigPopupHeight"
    [minHeight]="gridConfigMinPopupHeight"
    [width]="900"
    [minWidth]="750"
    [showCloseButton]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    (onResize)="onResizeGridConfigPopup($event)"
    container=".dx-viewport"
    [position]="{
        my: 'top',
        at: 'top',
        of: '.main-scroll-view .dx-scrollview-content',
        offset: { y: 70 }
    }"
    [visible]="visible">
    
    <div class="edit-grid-config-popup">
        <dx-form #gridConfigForm [colCount]="2" [formData]="fieldProps">
            <dxi-item itemType="group" [colSpan]="1" [colCount]="1">
                <dxi-item dataField="colSpan" [colSpan]="1" editorType="dxNumberBox" [editorOptions]="{ showSpinButtons: true }"></dxi-item>
                <dxi-item dataField="heightValue" [colSpan]="1" editorType="dxSelectBox" [editorOptions]="{ items: gridHeightOptions, valueExpr: 'value', displayExpr: 'name' }"></dxi-item>
                <dxi-item dataField="gridColumns" [label]="{text: 'Visible Grid Columns'}" template="gridColumnsTemplate">
                    <div *dxTemplate="let data of 'gridColumnsTemplate'">
                        <dx-data-grid *ngIf="fieldProps"
                            #gridColumnsGrid
                            class="grid-columns-grid"
                            [dataSource]="gridColumns"
                            [height]="gridConfigPopupGridHeight"
                            [showColumnHeaders]="false"
                            keyExpr="column"
                            [(selectedRowKeys)]="fieldProps[data.dataField]"
                            (onToolbarPreparing)="onColumnsGridToolbarPreparing($event)"
                            (onSelectionChanged)="onColumnsGridSelectionChanged($event)">                    
                            <dxo-scrolling mode="standard"></dxo-scrolling>
                            <dxo-paging [enabled]="false"></dxo-paging>
                            <dxo-selection mode="multiple"></dxo-selection>
                            <dxo-row-dragging
                                [data]="gridColumns"
                                group="gridFields"
                                [allowReordering]="true"
                                [onReorder]="onReorderGridFields">
                            </dxo-row-dragging>
                            <dxo-search-panel [visible]="true"></dxo-search-panel>
                            <dxi-column dataField="column" [visible]="false"></dxi-column>
                            <dxi-column dataField="columnName" [visible]="true"></dxi-column>
                        </dx-data-grid>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item dataField="datasourceFilter" [colSpan]="1" [label]="{text: 'Filter'}" template="datasourceFilterTemplate">
                <div *dxTemplate="let data of 'datasourceFilterTemplate'">
                    <dx-filter-builder
                        #filterBuilder
                        [allowHierarchicalFields]="true"
                        [fields]="filterBuilderFields"
                        [(value)]="filterBuilderValue"
                        [groupOperations]="['and', 'or']"
                        width="auto"
                        [height]="gridConfigPopupFilterHeight"
                        [customOperations]="filterBuilderCustomOperations"
                        (onContentReady)="onFilterBuilderContentReady($event)">
                        <dxo-filter-operation-descriptions
                            isBlank="is (Blank)"
                            isNotBlank="is not (Blank)">
                        </dxo-filter-operation-descriptions>
                        <dx-tag-box
                            *dxTemplate="let condition of 'tagBoxTemplate'"
                            [value]="condition.value"
                            [dataSource]="condition.field.lookup.dataSource"
                            [maxDisplayedTags]="9"
                            (onValueChanged)="condition.setValue($event.value)"
                            [valueExpr]="condition.field.lookup.valueExpr"
                            [displayExpr]="condition.field.lookup.displayExpr"
                            [grouped]="condition.field.editorOptions?.grouped"
                            width="auto"
                            showSelectionControls="true"
                            [searchEnabled]="true"
                            stylingMode="underlined">
                        </dx-tag-box>
                        <dx-select-box
                            *dxTemplate="let condition of 'comboSelectBoxTemplate'"
                            [value]="condition.value"
                            (onValueChanged)="retainCustomValue($event.value, condition)"
                            [dataSource]="condition.field.lookup.dataSource"
                            [valueExpr]="condition.field.lookup.valueExpr"
                            [displayExpr]="condition.field.lookup.displayExpr"
                            [searchEnabled]="true"
                            width="auto"
                            [acceptCustomValue]="true"
                            stylingMode="underlined"
                            (onCustomItemCreating)="customColumn($event, condition)"
                            (onEnterKey)="handleEnterKey($event)">
                        </dx-select-box>
                    </dx-filter-builder>
                </div>
            </dxi-item>
        </dx-form>
    </div>
    
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="editGridConfigPopupSaveButtonOptions"></dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="editGridConfigPopupCancelButtonOptions"></dxi-toolbar-item>
</dx-popup>
